import styled from 'styled-components';
import { H1, H2, SectionParent } from '../../../components/StyledComponents';

import React from 'react';
import lottie, { AnimationItem } from 'lottie-web';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #2a2f46;
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(3, 1fr);
  padding-left: 5rem;
  display: grid;
  @media (max-width: 768px) {
    padding-left: 0rem;
  }
`;

const HeroTitle = styled(H1)`
  margin-left: 2.5rem;
  color: #ffffff;

  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
  }
  @media (max-width: 520px) {
    color: #ac93ff;
  }
`;

const GridRight = styled.div`
  grid-column: span 2;
  padding-right: 8rem;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 1100px) {
    margin-top: 7rem;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;
const GridLeft = styled.div`
  grid-column: span 1;
  padding-left: 7rem;
  position: relative;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-left: 0;
    max-width: 15rem;
    justify-self: center;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  margin-left: 3rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #ffffff;
  @media (max-width: 768px) {
    text-align: center;
    margin-left: 0rem;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

export default class KioskSecondPage extends React.Component<any, any> {
  animation?: AnimationItem;
  isCMounted = true;

  constructor(props: any) {
    super(props);
    this.animation = undefined;
  }

  scrollFunction = () => {
    // Get the header
    const header = document.getElementById('section-one-kiosk');

    if (header && this.isCMounted) {
      // Get the offset position of the navbar
      const containerTop = header!.offsetTop;
      // const containerBottom = header!.offsetTop + header!.clientHeight;
      const currentBottomPosition = window.pageYOffset + window.innerHeight;
      const currentTopPosition = window.pageYOffset;
      if (
        currentBottomPosition > containerTop &&
        currentTopPosition < containerTop
      ) {
        // lottie.play('animation-kiosk')
        const scrollPercent = (45 * currentTopPosition) / containerTop;
        const scrollRounded = Math.round(scrollPercent);
        this.animation!.goToAndStop(scrollRounded, true);
      } else {
        this.animation!.goToAndStop(45, true);
      }
    }
  };

  componentWillUnmount() {
    this.isCMounted = false;
  }
  componentDidMount() {
    this.isCMounted = true;
    window.onscroll = this.scrollFunction;
    this.animation = lottie.loadAnimation({
      name: 'animation-kiosk',
      container: document.getElementById('lottie-animation-kiosk')!,
      loop: true,
      renderer: 'svg',
      autoplay: false,
      animationData: require('../../lottieAnimations/Kiosk_Product_Mobile.json'),
    });
  }

  render() {
    return (
      <div>
        <SectionOne id="section-one-kiosk">
          <SectionItemContainer>
            <GridLeft id="lottie-animation-kiosk" />
            <GridRight>
              <HeroTitle>Esper Manage Kiosk Management Solution</HeroTitle>
              <HeroSubTitle style={{ paddingTop: '1rem' }}>
                In the last year the Interactive Kiosk market has grown by 17.6%
                according to the second annual Kiosk Market Census Report. This
                means customers are responding to interactive kiosks as a means
                to talk to brands creating endless opportunities for companies
                and visionaries to deploy Kiosks across all major business
                verticals from education, healthcare, retail, to finance.
                <br />
                <br />
                <H2 style={{ color: '#5cbd9a' }}>
                  This is where Esper comes in!
                </H2>
                {/* <br /> */}
                We have just the perfect solution for you. Esper Manage provides
                the Industry’s first full-stack solution for Kiosks. Dynamically
                lock down your kiosks and significantly improve operational
                efficiency and performance. A powerful platform to suit all your
                needs!
              </HeroSubTitle>
            </GridRight>
          </SectionItemContainer>
        </SectionOne>
      </div>
    );
  }
}
